<template>
  <div class="notification" :id="'not-cont-' + index" :style="cssProps">
    <div class="notification-header" @click="expandNotification(index)">
      <fa class="notification-icon" id="status-icon" :icon="finalIcon" />
      <p class="notification-title">{{ status }} Invitation</p>

      <fa
        class="notification-icon"
        :id="'not-icon-' + index"
        icon="sort-down"
      />
    </div>
    <input
      type="hidden"
      :id="'not-val-' + index"
      name="expanded"
      value="false"
    />
    <div class="notification-icon"></div>
    <p
      class="notification-description from"
      :id="from != userEmail ? 'not-' + index : ''"
      :style="from == userEmail ? 'display: none' : ''"
    >
      <span :style="from != userEmail ? 'display: block' : 'display: none'">
        <span
          :style="status == 'Pending' ? 'display: contents' : 'display: none'"
          >You have a new invitation! User
          <span id="link"
            ><router-link :to="`/user_info?email=${from}`">{{
              linkText
            }}</router-link></span
          >
          want you to join them for a
          <span>{{ mode === "Walk" ? "walk" : "" }}</span
          ><span>{{ mode === "Play" ? "play date" : "" }}</span> and are waiting
          for your response<span class="loader"></span
        ></span>
        <span
          :style="status == 'Declined' ? 'display: contents' : 'display: none'"
          >You have declined this invitation from user
          <span id="link"
            ><router-link :to="`/user_info?email=${from}`">{{
              linkText
            }}</router-link></span
          ></span
        >
        <span
          :style="status == 'Accepted' ? 'display: contents' : 'display: none'"
          >You have accepted this invitation from user
          <span id="link"
            ><router-link :to="`/user_info?email=${from}`">{{
              linkText
            }}</router-link></span
          >
          and it's up to you to meet.</span
        >
      </span>
    </p>
    <p
      class="notification-description to"
      :id="to != userEmail ? 'not-' + index : ''"
    >
      <span :style="to != userEmail ? 'display: block' : 'display: block'">
        Your invitation to
        <span id="link"
          ><router-link :to="`/user_info?email=${to}`">{{
            linkText
          }}</router-link></span
        >
        <span
          :style="status == 'Pending' ? 'display: contents' : 'display: none'"
        >
          is pending<span class="loader"></span
        ></span>
        <span
          :style="status == 'Declined' ? 'display: contents' : 'display: none'"
        >
          was declined.</span
        >
        <span
          :style="status == 'Accepted' ? 'display: contents' : 'display: none'"
        >
          was accepted.</span
        >
      </span>
    </p>
    <div class="action-buttons" :id="'action-buttons-' + index">
      <Button
        id="reject-btn"
        :text="from == userEmail ? 'Cancel' : 'Reject'"
        icon="thumbs-down"
        color="var(--danger)"
        @click="rejectInvitation(notId)"
      />
      <Button
        id="accept-btn"
        text="Accept"
        icon="thumbs-up"
        color="var(--success)"
        @click="from != userEmail ? acceptInvitation(notId) : null"
        :style="from != userEmail ? 'display: flex' : 'display: none'"
      />
    </div>
    <div class="notification-timestamp">
      <p>{{ finalDateTime }}</p>
    </div>
  </div>
  <div class="test"></div>
</template>

<script>
import Button from "@/components/Button.vue";
import axios from "axios";
import Swal from "sweetalert2";

let jwt;
let headers;
export default {
  name: "Notification",
  components: {
    Button,
  },
  props: {
    index: { type: String, default: "" },
    title: { type: String, default: "New notification" },
    desc: { type: String, default: "Notification description" },
    status: { type: String, default: "code" },
    time: { type: String, default: "" },
    notId: { type: String, default: "" },
    to: { type: String, default: "" },
    from: { type: String, default: "" },
    mode: { type: String, default: "" },
    userEmail: { type: String, default: "" },
  },
  methods: {
    expandNotification(index) {
      let self = this;
      let cont = document.querySelector("#not-cont-" + index);
      let desc = document.querySelector("#not-" + index);
      let icon = document.querySelector("#not-icon-" + index);
      let expaderValue = document.querySelector("#not-val-" + index).value;
      let btnCont = document.querySelector("#action-buttons-" + index);

      if (expaderValue === "true" || desc.style.height == "100%") {
        desc.style.height = "0";
        desc.style.display = "none";
        btnCont.style.display = "none";
        cont.style.height = "100%";
        icon.style.transform = "rotate(0deg)";
        expaderValue = "false";
      } else if (expaderValue === "false" || desc.style.height != "100%") {
        cont.style.height = "100%";
        desc.style.display = "block";

        if (self.status == "Pending") {
          btnCont.style.display = "flex";
        }

        desc.style.height = "100%";
        icon.style.transform = "rotate(180deg)";
        expaderValue = "true";
      }
    },
    rejectInvitation(index) {
      let self = this;
      headers["content-type"] = "application/json";
      axios
        .get(`${process.env.VUE_APP_BACKEND}/walk/${index}/decline`, {
          headers: headers,
        })
        .then(function () {
          Swal.fire("You have declined the invitation", "", "info")
            .then(() => {
              self.$router.go();
            })
            .catch((err) => {
              Swal.fire("Error", err, "error");
            });
        })
        .catch(function () {});
    },
    acceptInvitation(index) {
      let self = this;
      headers["content-type"] = "application/json";
      axios
        .get(`${process.env.VUE_APP_BACKEND}/walk/${index}/accept`, {
          headers: headers,
        })
        .then(function () {
          Swal.fire("You have accepted the invitation", "", "info")
            .then(() => {
              self.$router.go();
            })
            .catch((err) => {
              Swal.fire("Error", err, "error");
            });
        })
        .catch(function () {});
    },
  },
  data() {
    return {
      linkText: "",
    };
  },
  mounted() {
    let self = this;

    jwt = localStorage.getItem("jwt");

    if (jwt == null) {
      self.$router.push("/");
    }

    headers = { Authorization: "Bearer " + jwt };

    let queryID = "";
    if (self.to === this.userEmail) {
      queryID = self.from;
    } else if (self.from === this.userEmail) {
      queryID = self.to;
    }
    if (queryID !== "") {
      axios
        .get(`${process.env.VUE_APP_BACKEND}/users/info/${queryID}`, {
          headers: headers,
        })
        .then((res) => {
          // console.log(res);
          self.linkText = `${res.data.firstName} ${res.data.lastName}`;
        })
        .catch((err) => {
          console.error(err);
          self.$router.push("/");
          self.linkText = queryID;
        });
    }
  },
  computed: {
    cssProps() {
      let display = "none";
      let color = "#0000";
      if (this.status !== "code") {
        display = "block";
        if (this.status == "Pending") {
          color = "orange";
        } else if (this.status == "Declined") {
          color = "red";
        } else if (this.status == "Accepted") {
          color = "green";
        }
      }
      return {
        "--icon-display": display,
        "--icon-clr": color,
      };
    },
    finalIcon() {
      if (this.status == "Pending") {
        return "hourglass-half";
      } else if (this.status == "Declined") {
        return "times-circle";
      } else if (this.status == "Accepted") {
        return "check-circle";
      } else {
        return "code";
      }
    },
    finalDateTime() {
      let dateTime = new Date(this.time);
      let options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour12: false,
      };
      return dateTime.toLocaleTimeString("en-GB", options);
    },
  },
};
</script>

<style scoped>
.notification {
  min-width: 15em;
  width: 100%;
  max-width: 35em;
  background: white;
  border-radius: var(--border-radius);
  padding: 1rem;
  margin-block: 1em;
  transition: var(--transition);
  position: relative;

  box-shadow: 0 0.1rem 2rem hsla(0, 0%, 0%, 0.05);
  overflow: visible;
}

.notification-header {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  gap: var(--gap);
  cursor: pointer;
  font-weight: bold;
  font-size: 1.2rem;
  position: relative;
}

.notification:hover,
.notification:focus {
  background: var(--faint-bg);
  color: var(--light-clr);
}

.notification:hover *,
.notification:focus * {
  color: var(--light-clr);
}

.notification-description {
  opacity: 1;
  height: 0;
  color: var(--dark-clr);
  z-index: 1;
  padding: 1em 2em;
  text-align: start;
  font-weight: lighter;
  font-size: 0.9rem;
  display: none;
}

.notification-description span#link {
  font-weight: bolder;
  text-decoration: underline;
}

.notification-icon {
  transition: var(--transition);
}

#status-icon {
  color: var(--icon-clr);
}

.notification:hover #status-icon,
.notification:focus #status-icon {
  --icon-clr: var(--light-clr);
}

.notification-timestamp {
  font-size: 0.5em;
}

.action-buttons {
  overflow: visible;
  display: none;
  width: 100%;
  justify-content: space-between;
}
</style>
